export const environment = {
    production: false,
    apiURL: 'https://dev.soulcast.online',
    stripePublicKey: '',
    cookieDomain: 'dev.soulcast.online'
};